import { render, staticRenderFns } from "./VirtualScroller.vue?vue&type=template&id=10efbe9f"
import script from "./VirtualScroller.vue?vue&type=script&lang=js"
export * from "./VirtualScroller.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports